import React from 'react'

const ChatInput = ({
    value,
    onChange,
    onSend,
    disabled,
    placeholder,
    sendLabel,
}) => (
    <div className="chat-input">
        <input
            type="text"
            value={value}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
            onKeyUp={(e) => e.key === 'Enter' && !disabled && onSend(value)}
            disabled={disabled}
        />
        <button
            onClick={() => onSend(value)}
            disabled={disabled || !value.trim()}
        >
            {disabled ? '...' : sendLabel}
        </button>
    </div>
)

export default ChatInput
